import { systemCode, xs_languageCode } from '..';
import { TENNIS } from './constants';
import { parseBetsData } from "./parseBetsData";
import parseJerseys from './parseJerseys';
import { byRanking, filterByCustomizedState, formatDate, formatDateWithWeekDay, getLiveAggs, getPalAvvFromDesc, getPrematchAggs, getRanking, getSplitDesc, iconCategoryCssClass, isCategoryToBeHidden, isSportToBeHidden, isTournamentToBeHidden } from './utils.js';
import { getLabel } from '../InitData';
import { parseAdditionalData } from './parseAdditionalData.js';


export let localizedScoreLabels = null;

export function existsSport(data, sportId) {
    return data?.sportById?.[sportId];
}

export function existsCountry(data, sportId, countryId) {
    return data?.sportById?.[sportId]?.categoryById?.[countryId];
}

export function existsTournament(data, sportId, categoryId, tournamentId) {
    const uniqueId = `${sportId}_${categoryId}_${tournamentId}`;
    return data?.tournamentByUniqueId?.[uniqueId];
}

export function parseTournamentEvents(data, tournament, aggregate, idAggregata, isLive, compattaParametriche) {
    function getUrlPath(tournament, match, desc) {
        desc = desc.replace(/-/g, 'vs').replace(/\s+/g, '-').replace(/\//g, '-');
        const url = `${tournament.urlPath}/${desc}_${tournament.uniqueId}_${match.p}_${match.a}`;
        return url.toLocaleLowerCase();
    }

    return tournament.events.map(m => {
        const matchDesc = m.dsl[xs_languageCode];
        const [desc, avvRef] = getPalAvvFromDesc(matchDesc);
        const uniqueId = `${tournament.uniqueId}_${m.bid}`;
        const matchData = {
            sportRef: tournament.sportRef,
            tournamentRef : m.it,
            pal: m.p,
            avv: m.a,
            id: m.bid,
            desc: desc,
            uniqueId,
            alias: m.al,
            sportDesc: data.sportById[tournament.sportRef].descrizione,
            tournamentDesc: tournament.descrizione,
            timestamp: m.ts,
            seoSettings: m.seo,
            seoSettingsAdds: m.seoa,
            urlPath: getUrlPath(tournament, m, desc),
            urlPathSeo: getUrlPathSeo({...m,seoSettings:m.seo}),
            urlPathSeoSettings: getUrlPathSeoSettings({...m,seoSettingsAdds:m.seoa})
        };

        const betsData = parseBetsData(matchData, aggregate, idAggregata, m.scs, isLive, compattaParametriche);
        const [team1, team2] = getSplitDesc(matchData.desc);

        const formattedDate = formatDateWithWeekDay(m.ts);

        const match = {
            ...betsData,
            additionalData: parseAdditionalData(m.add),
            alias: m.al,
            avv: m.a,
            avvRef,
            categoryRef: tournament.categoryRef,
            competitorIdAway: m.cida,
            competitorIdHome: m.cidh,
            date: formattedDate.dayMonthYear,
            dateShort: formattedDate.dayMonthShort,
            dateShortYear: formattedDate.dayMonthYearShort,
            desc: matchData.desc,
            favorite: false,
            geniusId: m.gid,
            id: m.bid,
            isLive: m.lv,
            jerseys: parseJerseys(m.j, tournament.sportRef),
            info: m.v,
            lsportWidgetId: m.lswid,
            openAggregata: m.oa,
            openMacrogruppo: m.om,
            pal: m.p,
            plus: m.pl,
            plusByAggregateId : m.plba,
            round: m.r,
            score: m.scr != null ? parseScore(m.scr, tournament.sportRef) : null,
            sportDesc: data.sportById[tournament.sportRef].descrizione,
            sportRef: tournament.sportRef,
            sportUrlPath: tournament.sportUrlPath,
            sportUrlPathSuffix: tournament.sportUrlPathSuffix,
            team1,
            team2,
            time: formatDate(m.ts).time,
            timestampDB: m.ts,
            tournamentDesc: tournament.descrizione,
            tournamentRef: tournament.id,
            tournamentUrlPath: tournament.urlPath,
            tournamentUrlPathSeo: getUrlPathSeo(tournament),
            tournamentUrlPathSeoSettings: getUrlPathSeoSettings(tournament),
            tournamentUrlPathSuffix: tournament.urlPathSuffix,
            uniqueId,
            urlPath: getUrlPath(tournament, m, desc),
            urlPathSeo: getUrlPathSeo(matchData),
            urlPathSeoSettings: getUrlPathSeoSettings(matchData)
        };
        Object.assign(match, betsData);
        return match;
    }).sort((a, b) => a.timestampDB.localeCompare(b.timestampDB));
}

export function buildMenuData(menuData) {
    window.isCotaExtraEnabled = (menuData.ioes?.[systemCode] ?? null) != null;

    const data = {
        sport: parseMenuData(menuData.sps),
        sportById: {},
        tournamentByUniqueId: {},
        showIncreasedOddsButton: window.isCotaExtraEnabled
    };
    
    data.sport.forEach(sport => {
        sport.urlPath = (sport.descrizione.replace(/\s+/g, '-')).toLocaleLowerCase();
        sport.urlPathSuffix = `_${sport.id}`;
        sport.urlPathSeo = getUrlPathSeo(sport);
        sport.urlPathSeoSettings =  getUrlPathSeoSettings(sport);
        data.sportById[sport.id] = sport;
        sport.categories.forEach(function(category, i) {
            category.urlPath = (sport.urlPath+'/'+category.descrizione.replace(/\s+/g, '-')).toLocaleLowerCase();
            category.urlPathSuffix = `_${sport.id}_${category.id}`;
            category.urlPathSeo = getUrlPathSeo(category);
            category.urlPathSeoSettings = getUrlPathSeoSettings(category);
            category.sportRef = sport.id;
            const uniqueId = `${sport.id}_${category.id}`;
            category.uniqueId = uniqueId;
            
            if (i === 0) {
                sport.categoryById = {};
            }
            sport.categoryById[category.id] = category;
            category.tournaments.forEach((tournament, i) => {
                tournament.urlPath = (sport.urlPath+'/'+tournament.descrizione.replace(/\s+/g, '-')).toLocaleLowerCase();
                tournament.urlPathSeo = getUrlPathSeo(tournament);
                tournament.urlPathSeoSettings = getUrlPathSeoSettings(tournament);
                tournament.sportRef = sport.id;
                tournament.categoryRef = category.id;
                const uniqueId = `${category.uniqueId}_${tournament.id}`;
                tournament.uniqueId = uniqueId;
                tournament.urlPathSuffix = `_${tournament.uniqueId}`;
                tournament.categoryUrlPath = category.urlPath;
                tournament.categoryUrlPathSuffix = category.urlPathSuffix;
                tournament.categoryUrlPathSeo = getUrlPathSeo(category);
                tournament.categoryUrlPathSeoSettings = getUrlPathSeoSettings(category);
                tournament.sportUrlPath = sport.urlPath;
                tournament.sportUrlPathSuffix = sport.urlPathSuffix;

				if (i === 0) {
                    category.tournamentById = {};
                }

                if (tournament.events.length > 0) {
                    const aggregate = tournament.aggregate.map(ag => ag.idAggregata);
                    tournament.events = parseTournamentEvents(data, tournament, aggregate, tournament.ba, false, false);
                }
                category.tournamentById[tournament.id] = tournament;
                data.tournamentByUniqueId[uniqueId] = tournament;
            });
        });
    });

    // Merges two sports into one
    function mergeSport(target, source) {
        Object.assign(target.filters, source.filters);
        target.categories = target.categories.concat(source.categories);
        target.categories.forEach(function(c){
            if(c){
                c.sportScRef = target.id;
            }
        })
        target.isLive = source.isLive ? true : target.isLive;
        target.eventsCount += source.eventsCount;
    }

    // Here we process sports groupings (i.e. multiple sports merged into one)
    // At the end of the process toRemove contains the IDs of the sports that have been merged into their respective grouping,
    // which need to be removed from the final sports list (but they have to be kept in the map for future reference)
    const toRemove = new Set();
    menuData.scd && menuData.scd.lst && menuData.scd.lst.forEach(g => {
        // The first sport of the grouping is used as the base
        const firstSport = data.sportById[g.sps[0]];
        if (firstSport == null) {
            return;
        }
        toRemove.add(firstSport.id);
        const desc = g.dsl[xs_languageCode];
        const sport = {
            ...firstSport,
            descrizione: desc,
            iconClass: g.ico,
            id: `sc-${g.cid}`,
            ranking: g.rnk,
            urlPath: (desc.replace(/\s+/g, '-')).toLocaleLowerCase(),
            urlPathSuffix: `_sc-${g.cid}`
        };
        // Iterate though all the other sports of the grouping
        g.sps.slice(1).forEach(id => {
            const sp = data.sportById[id];
            if (sp == null) {
                return;
            }
            toRemove.add(sp.id);
            const toMerge = {...sp};
            // Merge the current sport with the base sport of the grouping
            mergeSport(sport, toMerge);
        });

        data.sport.push(sport);
        data.sportById[sport.id] = sport;
    });

    // Remove the sports that have been grouped into other sports
    data.sport = data.sport.filter(sp => !toRemove.has(sp.id)).sort(byRanking);

    return data;
}

function freezeMap(map) {
    for (const k in map) {
        Object.freeze(map[k]);
    }
    return Object.freeze(map);
}

function parseOdds(odds, betId, freeze = false) {
    return odds.map(odd => {
    	const parsedOdd = {
            id: odd.ce,
            desc: odd.ds,
            ranking: odd.rnk,
            value: null,
            tooltip: odd.tlt,
            tooltipByHandicap: odd.tlh,
            betId: betId,
            aliasListDefault: Object.freeze(odd.ald),
            aliasByHandicap: freezeMap(odd.alps),
            aliasBySystemCode: freezeMap(odd.alsys ? odd.alsys : null),
            aliasHandicapBySystemCode: freezeMap(odd.alsysp ? odd.alsysp : null)
        };
        if (freeze) {
            Object.freeze(parsedOdd);
        }
        return parsedOdd;
    }).sort(byRanking);
}


export const specialIncreasedBets = {
		superOdds : {},
		extraOdds : {},
		getBet : function (scomSogei, handicap){
			const key = [scomSogei, handicap].join("_");
			return this.superOdds[key]? this.superOdds[key] : this.extraOdds[key];
		}
};


export function parseBet(bet, agg, freeze = false) {
    const odds = parseOdds(bet.eas, bet.cs);
	let betDesc = bet.ds;
	if(bet.dss && bet.dss[systemCode]){
		betDesc = bet.dss[systemCode];
	}
    const parsedBet = {
        id: bet.cs,
        desc: betDesc,
        ranking: bet.rnk,
        parametrica: bet.par,
        handicap: bet.h,
        tipoHandicap: bet.th,
        calculateHandicapDescription: bet.chd,
        handicapTableDesc: bet.dth,
        legabile : bet.leg,
        odds,
        forceAntepost: bet.fant,
        liveTimer: bet.tl,
        mainLine: bet.ml,
        hideHandicap: bet.sjo,
        handicapInfo: bet.ia,
        aggId: agg?.id ?? null,
        aggDesc: agg?.ds ?? null,
        extraOddsMarket : bet.sex,
        superOddsMarket : bet.sq,
        combinationType : bet.comt,
        miminumOddForOtherSelections : bet.comt? bet.qmo : 0,
        nativeOddsLength : bet.nef
    };

    if (parsedBet.extraOddsMarket) {
    	const key = `${parsedBet.id}_${parsedBet.handicap}`;
    	specialIncreasedBets.extraOdds[key] = parsedBet;
    } else if (parsedBet.superOddsMarket) {
    	const key = `${parsedBet.id}_${parsedBet.handicap}`;
    	specialIncreasedBets.extraOdds[key] = parsedBet;
    }

    if (freeze) {
        Object.freeze(parsedBet);
    }
    
    return parsedBet;
}

const allAggById = new Map();
export function getAllAgg(isLive, sportId) {
    return allAggById.get(`${isLive ? 'lv' : 'pr'}_${sportId}`);
}
const mainAggById = new Map();
export function getMainAgg(isLive, sportId) {
    return mainAggById.get(`${isLive ? 'lv' : 'pr'}_${sportId}`);
}
const cotaOrExtra = new Set();
export function isCotaOrExtra(isLive, sportId, aggId) {
    return cotaOrExtra.has(`${isLive ? 'lv' : 'pr'}_${sportId}_${aggId}`);
}

export function parseAggregateData(data) {
    function parseBets(bets, agg) {
        if (bets == null) {
            return [];
        }
        return bets.map(bet => {
            const parsedBet = parseBet(bet, agg, true);
            const betId = `${parsedBet.id}_${parsedBet.handicap}`;
            betById[betId] = parsedBet;
            return parsedBet;
        }).sort(byRanking);
    }

    function parseAggregata(sportId, agg) {
        const bets = parseBets(agg.scs, agg);
        const parsedAgg = {
            idAggregata: agg.id,
            descrizione: agg.ds,
            ranking: agg.rnk,
            isPrincipale: agg.pn,
            scommesse: bets,
            compattate: freezeMap(agg.cmp),
            localeCmpDesc : freezeMap(agg.lcmp),
            sportId,
            whitelistedSystemCodes : agg.wsy
        };
        Object.freeze(parsedAgg);
        bets.forEach(bet => {
        	const betId = `${bet.id}_${bet.handicap}`;
        	const betIdSport = `${sportId}_${bet.id}_${bet.handicap}`;
            if (agsByBetId[betId] == null) {
            	agsByBetId[betId] = [];
            }
            if(agsByBetIdAndSportId[betIdSport] == null){
            	agsByBetIdAndSportId[betIdSport] = [];
            }
            agsByBetId[betId].push(parsedAgg);
            agsByBetIdAndSportId[betIdSport].push(parsedAgg);
        });
        
        return parsedAgg;
    }

    const betById = window.xs_ag.betById;
    const aggregatePrematchBySportId = window.xs_ag.aggregatePrematchBySportId;
    const aggregateLiveByIdSport = window.xs_ag.aggregateLiveByIdSport;
    const agsByBetId = window.xs_ag.agsByBetId;
    const agsByBetIdAndSportId = window.xs_ag.agsByBetIdAndSportId;
    const sports = data.ags;
    for (let sportId in sports) {
        sportId = parseInt(sportId, 10);
        const sport = sports[sportId];
        if (typeof sport.pr !== 'undefined') {
            aggregatePrematchBySportId[sportId] = {};
            sport.pr.forEach(ag => {
            	const loadThis = !ag.wsy || (ag.wsy?.[systemCode]);
            	if(loadThis){
                 	const parsedAgg = parseAggregata(sportId, ag);
                	aggregatePrematchBySportId[sportId][ag.id] = parsedAgg;
	                if (parsedAgg.idAggregata < 0) {
	                    allAggById.set(`pr_${sportId}`, parsedAgg);
	                }
	                if (parsedAgg.isPrincipale) {
	                    mainAggById.set(`pr_${sportId}`, parsedAgg);
	                }
	                if (ag.coex === true) {
	                    cotaOrExtra.add(`pr_${sportId}_${ag.id}`);
	                }           	
            	}
            	else {
            		console.log("Aggregata " + ag.id + " non ammessa per system code " + systemCode);
            	}

            });
        }
        if (typeof sport.lv !== 'undefined') {
            aggregateLiveByIdSport[sportId] = {};
            sport.lv.forEach(ag => {
                const parsedAgg = parseAggregata(sportId, ag);
                aggregateLiveByIdSport[sportId][ag.id] = parsedAgg;
                if (parsedAgg.idAggregata < 0) {
                    allAggById.set(`lv_${sportId}`, parsedAgg);
                }
                if (parsedAgg.isPrincipale) {
                    mainAggById.set(`lv_${sportId}`, parsedAgg);
                }
                if (ag.coex === true) {
                    cotaOrExtra.add(`lv_${sportId}_${ag.id}`);
                }
            });
        }
    }
}

export function parsePrintAgg(data) {
    function parseBets(bets, agg) {
        if (bets == null) {
            return [];
        }
        return bets.map(bet => parseBet(bet, agg)).sort(byRanking);
    }

    function parseAgg(agg) {
        const bets = parseBets(agg.scs, agg);
        const parsedAgg = {
            idAggregata: agg.id,
            descrizione: agg.ds,
            ranking: agg.rnk,
            isPrincipale: agg.pn,
            scommesse: bets,
            compattate: agg.cmp,
            localeCmpDesc : agg.lcmp	
        };
        
        return parsedAgg;
    }

    return parseAgg(data);
}

function getFilters(filtersMap, isLive) {
    if (isLive && typeof filtersMap === 'object') {
        filtersMap['LIVE'] = 1;
    }
    
    return filtersMap;
}

export function parseMenuData(data) {
    function parseTournaments(sportId, tournaments, iconClass, categoryIcon) {
        const aggregateById = getPrematchAggs(sportId);

        const filteredTournaments = filterByCustomizedState(tournaments);
        return filteredTournaments.map(function(tournament) {
            const aggregate = [];
            tournament.ags.forEach(aggId => {
                const agg = aggregateById[aggId];
                if (agg != null) {
                    aggregate.push(agg);
                }
            })
            aggregate.sort(byRanking);

            let liveData = null;
            if (tournament.lv) {
                const aggregate = [];
                tournament.ld.ags && tournament.ld.ags.forEach(ag => {
                    const agg = getLiveAggs(sportId, ag);
                    if (agg != null) {
                        aggregate.push(agg);
                    }
                })
                aggregate.sort(byRanking);

                liveData = {
                    aggregate,
                    eventsCount: tournament.ld.ne
                };
            }

            return {
                id: tournament.id,
                descrizione: tournament.dsl[xs_languageCode],
                ranking: getRanking(tournament),
                isLive: tournament.lv,
                eventsCount: tournament.ne,
                eventsCountByFilter: tournament.net,
                events: tournament.el || [],
                aggregate,
                liveData,
                iconClass,
                categoryIcon,
                filters: getFilters(tournament.tfs, tournament.lv),
                seoSettings: tournament.seo,
                seoSettingsAdds: tournament.seoa,
                ba: tournament.ba,
                seasonId: tournament.sid,
                betBuilder : tournament.bb
            };
        }).sort(byRanking);
    }

    function parseCategories(sportId, categories) {
        return filterByCustomizedState(categories).map(category => {
            const categoryIcon = iconCategoryCssClass(sportId, category.id, category.ic);
            const tournaments = parseTournaments(sportId, category.tns, category.ic, categoryIcon);

            return {
                id: category.id,
                descrizione: category.dsl[xs_languageCode],
                ranking: getRanking(category),
                isLive: category.lv,
                tournamentsCount: category.ne,
                tournamentsCountByFilter: category.net,
                tournaments,
                filters: getFilters(category.tfs, category.lv),
                iconClass: category.ic,
                categoryIcon,
                seoSettings: category.seo,
                seoSettingsAdds: category.seoa
            };
        }).sort(byRanking);
    }

    function parseSports(sports) {
        return filterByCustomizedState(sports).map(function(sport) {
            const categories = parseCategories(sport.id, sport.cts);

            return {
                id: sport.id,
                descrizione: sport.dsl[xs_languageCode],
                ranking: getRanking(sport),
                isLive: sport.lv,
                eventsCount: sport.ne,
                eventsCountByFilter: sport.net,
                categories,
                iconClass: sport.ic,
                filters: getFilters(sport.tfs, sport.lv),
                seoSettings: sport.seo,
                seoSettingsAdds: sport.seoa
            };
        }).sort(byRanking);
    }

    return parseSports(filterSportMenu(data));
}

export function filterSportMenu(data) {
    const filteredSports = [];
    
    // looping sports
    for (let ks in data) {
        const sport = data[ks];
        const filteredCategories = [];
        if (!isSportToBeHidden(sport.id, sport.dsl[xs_languageCode])) {
            // looping categories
            for (let kc in sport.cts) {
                const category = sport.cts[kc];
                const filteredTournaments = [];
                if (!isCategoryToBeHidden(category.id, category.dsl[xs_languageCode])) {
                    // looping tournaments
                    for (let kt in category.tns) {
                        const tournament = category.tns[kt];
                        if (!isTournamentToBeHidden(tournament.id, tournament.dsl[xs_languageCode])) {
                            filteredTournaments.push(tournament);
                        }
                    }		
                }
                if (filteredTournaments.length > 0) {
                    category.tns = filteredTournaments;
                    filteredCategories.push(category);
                }
            }    	
        }
        if (filteredCategories.length > 0) {
            sport.cts = filteredCategories;
            filteredSports.push(sport);
        } 	
    }

    return filteredSports;
}

export function getLocalizedScoreLabel(sportId, nativeScoreLabel) {
	if (!localizedScoreLabels) {
		localizedScoreLabels = {};
        const labels = getLabel('scores.localized_labels');
        if (labels.length > 0) {
            try {
                const localizedScoreLabelsTemp = JSON.parse(labels);
                for (let kk in localizedScoreLabelsTemp) {
                    localizedScoreLabels[(kk + "").toUpperCase().trim()] = localizedScoreLabelsTemp[kk];
                }	
            } catch(e) {
                console.log(e);
            }
        }
	}

	const keySearch = nativeScoreLabel.toUpperCase().trim();
	return localizedScoreLabels[sportId + "_" + keySearch] ||
		   localizedScoreLabels[keySearch] || 
		   nativeScoreLabel;
}

export function parseScore(scr, sportRef) {
    function formatScores(scores) {
        const periodsSet = new Set();
        const formattedScores = [];
        for (let i = 0; i <= 6; i++) {
            if (i <= 4 || (i === 5 && sportRef !== 4) || (i === 6 && sportRef !== 23)) {
                const score = scores[i]?.[`score${i + 1}`];
                if (score?.length > 0) {
                    let scoreObj = null;
                    if (score.includes('#')) {
                        const parts = score.split('#');
                        const p = getLocalizedScoreLabel(sportRef, parts[0].replace(/\s+/g, ''));
                        const s = parts[1];
                        const sep = s.includes(':') ? ':' : '-';
                        const [s1, s2] = s.replace(/\s+/g, '').split(sep);
                        scoreObj = {isTotalScore: false, p: p, s1, s2};
                    } else {
                        const [s1, s2] = score.split(' - ');
                        scoreObj = {isTotalScore: true, p: 'T', s1, s2};
                    }
                    // Avoid duplicates
                    if (!periodsSet.has(scoreObj.p)) {
                        periodsSet.add(scoreObj.p);
                        formattedScores.push(scoreObj);
                    }
                }
            }
        }
        return formattedScores;
    }

    const partialScores = scr?.scps?.map(function(s, i) {
        const key = "score" + (i + 2);
        const parts = s?.split("#");
        let value = parts?.length > 1 && parts[1] && (getLocalizedScoreLabel(sportRef, parts[0].replace(/\s+/g, '')) + '#' + parts[1]);
        // Handle Tennis advantage
        if (sportRef === TENNIS && parts[0] === 'G') {
            const scores = parts[1].split(':');
            const team1Score = parseInt(scores[0], 10), team2Score = parseInt(scores[1], 10);
            if (team1Score === 50) {
                value = `G#A:${team2Score}`;
            } else if (team2Score === 50) {
                value = `G#${team1Score}:A`;
            }
        }
        return {
            [key]: value
        }
    });

    let periodo = (scr?.st)? getLocalizedScoreLabel(sportRef, scr.st) : null;
    // if (scr?.st) {
    //     periodo = getLocalizedStatus(scr.st, xs_languageCode, sportRef);
    // }

    let time = null;
    if (scr?.t != null) {
        const parsed = parseInt(scr.t, 10);
        if (!isNaN(parsed) && parsed > 0) {
            time = `${parsed}'`;
        }
    }

    const score = {
        periodo,
        srv: scr?.srv,
        currentMinute: time,
        combinedScore: '',
        team1Score: null,
        team2Score: null,
        currentScore: [{score1: scr?.sc ?? ''}].concat(partialScores)
    };
    if (scr && scr.sc) {
        try {
            score.combinedScore = scr.sc;
            const [team1Score, team2Score] = getSplitDesc(scr.sc);
            score.team1Score = team1Score;
            score.team2Score = team2Score;
        } catch (e) {}
    }
    score.formattedScores = formatScores(score.currentScore);

    if (sportRef === 4) {
        try {
            let parts = null;
            if (score.currentScore[6] == null) {
                parts = score.currentScore[5].score6.replace("T#", "").split('-');
            } else {
                parts = score.currentScore[6].score7.replace("T#", "").split('-');            
            }
            let team1Score = parts[0];
            let team2Score = parts[1];
            if (team1Score != null && team2Score != null) {
                score.combinedScore = `${team1Score}-${team2Score}`;
            }
        } catch (error) {
                    
        }
    }
    
    score.sourceServing = '';
    score.serviceIconType = null;
    if (sportRef === 5) {
        score.sourceServing = 'assets\\img\\sport\\icone\\pallina_tennis.svg';
        score.serviceIconType = 'service-icon-tennis';
    } else if (sportRef === 20 || sportRef === 23 || sportRef === 34) {
        score.sourceServing = 'assets\\img\\sport\\icone\\service-volley.png';
        score.serviceIconType = 'service-icon-volley';
    }

    return score;
}

export const dataFetchReducer = (state, action) => {
    switch (action.type) {
        case 'FETCH_INIT':
        return {
            ...state,
            isLoading: true
        };
        case 'FETCH_SUCCESS':
        return {
            isLoading: false,
            isError: false,
            data: action.payload,
        };
        case 'FETCH_FAILURE':
        return {
            isLoading: false,
            isError: true,
            data: null
        };
        default:
        throw new Error();
    }
};

/*export function getUrlPathSeo(data){

    try {
        const seoSettings = data && data.seoSettings?JSON.parse(data.seoSettings):null;
        const seoSettingSysCodeLang = seoSettings && (seoSettings[systemCode]?seoSettings[systemCode]:seoSettings['DEFAULT'])?.[xs_languageCode];
        return (seoSettingSysCodeLang && seoSettingSysCodeLang.pn) || seoSettingSysCodeLang;
    }catch(err){
        console.log(err);
    }

    return null;
}

export function getUrlPathSeoSettings(data){

    try {
        const seoSettings = data && data.seoSettings?JSON.parse(data.seoSettings):null;
        const seoSettingSysCodeLang = seoSettings && (seoSettings[systemCode]?seoSettings[systemCode]:seoSettings['DEFAULT'])?.[xs_languageCode];
        return seoSettingSysCodeLang;
    }catch(err){
        console.log(err);
    }

    return null;
}*/

export function getUrlPathSeoLive(data){

    try {
        const seoSettingsLive = data && data.seoSettingsLive?JSON.parse(data.seoSettingsLive):null;
        const seoSettingLiveByDefault = seoSettingsLive && (seoSettingsLive['DEFAULT'])?.[xs_languageCode];
        const seoSettingLiveBySysCode = seoSettingsLive && (seoSettingsLive[systemCode])?.[xs_languageCode];
        const pathSeoLiveByDefault = seoSettingLiveByDefault && seoSettingLiveByDefault.pn;
        const pathSeoLiveBySysCode = seoSettingLiveBySysCode && seoSettingLiveBySysCode.pn;
        return pathSeoLiveBySysCode || pathSeoLiveByDefault || seoSettingLiveBySysCode || seoSettingLiveByDefault;

    }catch(err){
        console.error(err);
    }

    return null;
}

export function getUrlPathSeo(data){

    try {
        const seoSettings = data && data.seoSettings?JSON.parse(data.seoSettings):null;
        const seoSettingByDefault = seoSettings && (seoSettings['DEFAULT'])?.[xs_languageCode];
        const seoSettingBySysCode = seoSettings && (seoSettings[systemCode])?.[xs_languageCode];
        const pathSeoByDefault = seoSettingByDefault && seoSettingByDefault.pn;
        const pathSeoBySysCode = seoSettingBySysCode && seoSettingBySysCode.pn;
        return pathSeoBySysCode || pathSeoByDefault || seoSettingBySysCode || seoSettingByDefault;

    }catch(err){
        console.error(err);
    }

    return null;
}

export function getUrlPathSeoSettings(data){

    try {
        const seoSettingsAdds = data && data.seoSettingsAdds?JSON.parse(data.seoSettingsAdds):null;
        const seoSettingAddsByDefault =   seoSettingsAdds && (seoSettingsAdds['DEFAULT'])?.[xs_languageCode];
        const seoSettingAddsBySysCode  =   seoSettingsAdds && (seoSettingsAdds[systemCode])?.[xs_languageCode];
        return (seoSettingAddsBySysCode && Object.keys(seoSettingAddsBySysCode).length > 0)?seoSettingAddsBySysCode:seoSettingAddsByDefault;
    }catch(err){
        console.error(err);
    }

    return null;
}
